import theme from '^/theme';
import { Language, PhotoRequestTabTypes } from '^/types';
import React from 'react';
import styled from 'styled-components';
import Text from './text';

interface PhotoRequestTabsProps {
  tabs: PhotoRequestTabTypes[];
  activeTab: PhotoRequestTabTypes;
  onTabClick(tabId: PhotoRequestTabTypes): void;
  testId?: string;
  completedCount?: number;
}

const TabsContainer = styled.div({
  display: 'flex',
  borderBottom: `1px solid ${theme.colors.coolGray[100]}`,
  gap: '6px',
  paddingLeft: '20px',
});

const TabItem = styled.div<{ isActive: boolean }>(({ isActive }) => ({
  padding: '12px 6px',
  fontSize: '14px',
  fontWeight: isActive ? '600' : '400',
  color: isActive ? theme.colors.primary : theme.colorTokens.textGrayLight,
  cursor: 'pointer',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',

  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    height: '3px',
    backgroundColor: isActive ? theme.colors.primary : 'transparent',
  },
}));

const CompletedCount = styled.div({
  padding: '4px 5px',
  borderRadius: '4px',
  backgroundColor: theme.colors.lightBlue[400],
  color: theme.colors.white[100],
  fontSize: '12px',
  fontWeight: '700',
});

export const PhotoRequestTabs: React.FC<PhotoRequestTabsProps> = ({
  tabs,
  activeTab,
  onTabClick,
  testId,
  completedCount,
}) => (
  <TabsContainer data-testid={testId}>
    {tabs.map(tab => (
      <TabItem
        key={tab}
        isActive={activeTab === tab}
        onClick={() => onTabClick(tab)}
        data-testid={`${testId}-${tab}`}
      >
        {Text[tab][Language.EN_US]}
        {Boolean(completedCount) && tab === PhotoRequestTabTypes.COMPLETED && (
          <CompletedCount>{completedCount}</CompletedCount>
        )}
      </TabItem>
    ))}
  </TabsContainer>
);

export default PhotoRequestTabs;
